import { createContext, useContext } from "react";

export interface PaginationState {
  numPages: number;
  numRecords: number;
  page: number;
  rowsPerPage: string;
  rowsPerPageOptions: string[];
  setNumRecords: React.Dispatch<React.SetStateAction<number>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setRowsPerPage: React.Dispatch<React.SetStateAction<string>>;
}

export const initialPaginationState: PaginationState = {
  numPages: 1,
  numRecords: 0,
  page: 1,
  rowsPerPage: "25",
  rowsPerPageOptions: ["25", "50", "100"],
  setNumRecords: () => null,
  setPage: () => null,
  setRowsPerPage: () => null,
};

export const PaginationContext = createContext<PaginationState | null>(null);

export const usePagination = () => {
  const context = useContext(PaginationContext);

  if (!context) {
    throw new Error("usePagination must be used within a PaginationProvider");
  }

  return context;
};
